// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"19b7dacc","536":"3d8143cf","770":"ef30b84c"}[chunkId] + ".chunk.js";
};